import Vue from 'vue'

export default {
  ADD_NEW_LICENSE (state, newLicense) {
    state.license.push(newLicense)
  },
  ADD_LICENSE (state, license) {
    state.license = license
  },
  UPDATE_LICENSE (state, license) {
    Object.assign(state.license.find(l => l.id === license.id), license)
  },
  CHANGE_LICENSE_PHOTO (state, license) {
    const l = state.license.find(s => s.id === license.id)
    l.photo = license.photo
  },
  ADD_LICENSE_PHOTO (state, license) {
    const l = state.license.find(l => l.id === license.id)
    Vue.set(l, 'photo', license.photo)
  },
  DELETE_LICENSE_PHOTO (state, id) {
    const l = state.license.find(l => l.id === id)
    Vue.set(l, 'photo', '')
  },
  DELETE_LICENSE (state, id) {
    state.license = state.license.filter(w => w.id !== id)
  },
  ADD_NEW_DEPONENTS_DATA (state, data) {
    state.deponentsData.push(data)
  },
  DELETE_DOCUMENT_TYPE (state, id) {
    state.documentTypes = state.documentTypes.filter(d => d.id !== id)
    state.documentType = null
  },
  CHANGE_DEPONENTS_DOCUMENT_FILE (state, data) {
    const deponentsData = state.documents.find(s => s.id === data.id)
    deponentsData.file = data.file
  },
  DELETE_DEPONENTS_DATA (state, id) {
    state.deponentsData = state.deponentsData.filter(d => d.id !== id)
  },
  ADD_DEPONENTS_DATA (state, data) {
    state.deponentsData = data.deponentsData
    state.emitentsData = data.emitentsData
  },
  ADD_NEW_DOCUMENT_TYPE (state, documentType) {
    state.documentTypes.push(documentType)
  },
  ADD_DOCUMENTS_TYPES (state, types) {
    state.documentTypes = types
  },
  ADD_NEWDOCUMENTS_TYPES (state, types) {
    state.newDocumentTypes = types.filter(d => d.additional_meta.__document)
  },
  ADD_DOCUMENT_TYPE (state, type) {
    state.documentType = type
  },
  ADD_DOCUMENTS (state, documents) {
    state.documents = documents
  },
  ADD_NEW_DOCUMENT (state, document) {
    state.documentType.documents.push(document)
  },
  UPDATE_DOCUMENT (state, doc) {
    Object.assign(state.documentType.documents.find(d => d.id === doc.id), doc)
  },
  DELETE_DOCUMENT (state, id) {
    state.documentType.documents = state.documentType.documents.filter(w => w.id !== id)
  },
  ADD_FINANCIAL_DOCUMENTS (state, docs) {
    state.fDocuments = docs
  },
  ADD_NEW_FINANCIAL_DOCUMENT (state, doc) {
    state.fDocuments.unshift(doc)
  },
  DELETE_FINANCIAL_DOCUMENT (state, id) {
    state.fDocuments = state.fDocuments.filter(d => d.id !== id)
  },
  UPDATE_FINANCIAL_DOCUMENT (state, doc) {
    Object.assign(state.fDocuments.find(d => d.id === doc.id), doc)
  },
  UPDATE_DOCUMENTS_ORDER (state, docs) {
    state.documentType.documents = docs
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/documents.js